<template>
  <div class="up__event" v-if="event && !event.deleted">
    <div class="up__event-edit">
      <timechanger
        class="time-changer__create-presence"
        :class="{'input-warning': event.tempIntersect}"
        lang="da"
        :start="event.start"
        :end="event.end"
        :isFiveMinutesInterval="false"
        @updateStart="updateStart"
        @updateEnd="updateEnd">
      </timechanger>
      <div @click="deleteEvent"
           class="up__event-delete pointer">
        <span class="icon-cross3"></span>
      </div>
    </div>
    <div class="up__event-sum">
      {{duration}}
    </div>
  </div>
</template>

<script>
  import timechanger from '../../TimeChanger.vue'
  import moment from 'moment'

  export default {
    components: {timechanger},
    props: {
      event: {
        type: Object
      }
    },
    data () {
      return {
        isOn: true
      }
    },
    computed: {
      durationAsMinutes () {
        let diff = moment(this.event.end).diff(this.event.start)
        let asMinutes = moment.duration(diff).asMinutes()
        this.$emit('duration', {tempId: this.event.tempId, asMinutes})
        return asMinutes
      },
      duration () {
        let hours = Math.floor(this.durationAsMinutes / 60)
        let minutes = (this.durationAsMinutes - (hours * 60))
        return hours + this.$t('vue2.presence.h') + ' ' + minutes + this.$t('vue2.presence.m')
      }
    },
    methods: {
      updateStart (startTime) {
        this.$emit('updateStart', {tempId: this.event.tempId, startTime})
      },
      updateEnd (endTime) {
        this.$emit('updateEnd', {tempId: this.event.tempId, endTime})
      },
      deleteEvent () {
        this.$emit('delete', this.event)
      },
      setEventPresence (val) {
        this.isOn = val
      }
    }
  }
</script>

<style>
  .up__event {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 50px;
    margin-bottom: 10px;
  }
  .up__event-edit {
    display: flex;
    align-items: center;
  }

  .up__event .up__event-delete {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #fa565a;
    color: white;
    padding-top: 1px;
  }

  .flex-2 {
    flex: 2;
  }

  .time-changer__create-presence > input{
    width: 70px;
    padding: 6px;
    border-radius: 4px;
    border: 1px solid #acb6be;
    text-align: center;
    background-color: #ffffff;
  }
  .time-changer__create-presence > input:first-child {
    margin-right: 10px;
  }

  .flex-tr.tr-weekdays-hours {
    padding: 10px;
  }
  .isNotPresence {
    opacity: 0.7;
  }

  .time-changer__create-presence input {
      width: 80px;
    border: 1px solid #acb6be;
    background: white;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 9px;
  }
</style>



// WEBPACK FOOTER //
// PresenceUserEditEvent.vue?98fa57dc